export const getImageFullPath = (imagePath) => {
  return `${process.env.REACT_APP_BASE_IMAGE_LOCATION}/${imagePath}`;
};
